import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type AuthenticateSessionResponsePayload = {
  challenges: number[]
}

export const AuthenticateSessionResponsePayloadSchema: CborSchema<AuthenticateSessionResponsePayload> =
  defineCborSchema<AuthenticateSessionResponsePayload>({
    challenges: CborField({ key: 0 }),
  })
